// extracted by mini-css-extract-plugin
export default {"wrapper":"CRMProductCategoryPage_wrapper__912Mq"};